import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './index.css';
import App from './App';

// API host for split deployments (static assets and API on different hostnames).
// Baked in at build time by CRA: REACT_APP_API_URL=https://api.example.com npm run build
// Empty default preserves relative URLs (dev proxy / same-origin reverse proxy setups).
axios.defaults.baseURL = process.env.REACT_APP_API_URL || '';

// Normalize FastAPI 422 validation errors (detail array) so existing error handlers show messages
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const data = error.response?.data;
    if (data?.detail && !data?.error) {
      const detail = data.detail;
      data.error = Array.isArray(detail)
        ? detail.map((d) => (d.loc ? `${d.loc.slice(1).join('.')}: ${d.msg}` : d.msg)).join('; ')
        : typeof detail === 'string'
          ? detail
          : String(detail);
    }
    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
